import { ActionIcon, Box, Checkbox, Group, Popover, ScrollArea, Text } from '@mantine/core';
import { IconColumns } from '@tabler/icons-react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AppConstants } from 'utils/constants';

// space kept between the bottom of the dropdown and the bottom of the window
const BOTTOM_PADDING = 24;
// dropdown chrome above/below the list: arrow offset, "Columns" label and dropdown padding
const DROPDOWN_CHROME = 70;
const MIN_HEIGHT = 120;

const ColumnFilterMenu = (props) => {
    const targetRef = useRef(null);
    const [opened, setOpened] = useState(false);
    const [maxHeight, setMaxHeight] = useState(302);

    const updateMaxHeight = useCallback(() => {
        const rect = targetRef.current?.getBoundingClientRect();
        if (!rect) return;
        setMaxHeight(Math.max(MIN_HEIGHT, window.innerHeight - rect.bottom - DROPDOWN_CHROME - BOTTOM_PADDING));
    }, []);

    useEffect(() => {
        if (!opened) return;
        updateMaxHeight();
        window.addEventListener('resize', updateMaxHeight);
        return () => window.removeEventListener('resize', updateMaxHeight);
    }, [opened, updateMaxHeight]);

    return (
        <Popover shadow='md' withArrow width={props.width??200} position='bottom-end' opened={opened} onChange={setOpened}>
            <Popover.Target>
                {/* <Button variant='default' rightIcon={<IconChevronDown size={14} />}>
                    Display Columns
                </Button> */}
                <ActionIcon ref={targetRef} size='lg' variant='default' onClick={() => setOpened((o) => !o)}>
                    <IconColumns size={16} stroke={AppConstants.ICON_STROKE_WIDTH} />
                </ActionIcon>
            </Popover.Target>

            <Popover.Dropdown px={0}>
                <Text px={'md'} pb={'md'} size={'xs'} color='dimmed'>
                    Columns
                </Text>
                <ScrollArea.Autosize maxHeight={maxHeight}>
                <Box pl={'md'} pr={'xs'}>
                {props.columns?.map((val, idx) => {
                    // const col = columns.find(column => column.accessor === val.accessor)
                    const checked = props.hiddenColumns.indexOf(val.accessor) < 0;
                    return (
                        <React.Fragment key={idx}>
                            {Object.hasOwn(val, 'show') ? (
                                <div key={idx} onClick={(e) => props.onChange('change', val, checked)}>
                                    <Group spacing={'xs'} mb={'md'}>
                                        <Checkbox checked={checked} onChange={() => {}}  />
                                        {/* <div style={{ width: 20 }}>{props.hiddenColumns.indexOf(val.accessor) < 0 ? <IconCheck size={14} /> : null}</div> */}
                                        <Text style={{cursor:'pointer'}} size={'sm'}>{val.Header}</Text>
                                    </Group>
                                </div>
                            ) : null}
                        </React.Fragment>
                    );
                })}
                </Box>
                </ScrollArea.Autosize>
            </Popover.Dropdown>
        </Popover>
    );
};

export default ColumnFilterMenu;
